import { render, staticRenderFns } from "./SnackErro.vue?vue&type=template&id=53aaba8c&"
import script from "./SnackErro.vue?vue&type=script&lang=js&"
export * from "./SnackErro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports